import React from 'react';
import './styles.css';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';

import { AuthProvider, useAuth } from './AuthContext';

import AuthScreen from './AuthScreen';
import Sidebar from './Sidebar';

import Dashboard from './Dashboard';
import Stock from './Stock';
import Ventas from './Ventas';
import Prestamos from './Prestamos';
import EmbajadorasAdmin from './EmbajadorasAdmin';
import Resumen from './Resumen';
import Movimientos from './Movimientos';
import { Calendario, Experiencias } from './Experiencias';

function PendingScreen({ logout }) {
  return (
    <div className="pending-screen">
      <div
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 48,
          color: 'var(--forest)',
        }}
      >
        FLORESIENDO
      </div>

      <h2>Cuenta pendiente</h2>

      <p>
        Tu cuenta está siendo revisada por la administradora.
        Te notificaremos cuando tengas acceso.
      </p>

      <button className="btn btn-ghost" onClick={logout}>
        Cerrar sesión
      </button>
    </div>
  );
}

function AdminLayout() {
  const { user, userData, loading, logout } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!user || !userData) {
    return <AuthScreen />;
  }

  if (!userData.approved && userData.role !== 'admin') {
    return <PendingScreen logout={logout} />;
  }

  const isAdmin = userData.role === 'admin';

  const currentPage =
    location.pathname.replace('/admin/', '') || 'dashboard';

  const setActive = (page) => {
    navigate(`/admin/${page}`);
  };

  return (
    <div className="app-layout">
      <Sidebar active={currentPage} setActive={setActive} />

      <main className="main-content">
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/admin/dashboard" />}
          />

          <Route
            path="dashboard"
            element={<Dashboard setActive={setActive} />}
          />

          <Route path="stock" element={<Stock />} />

          <Route path="ventas" element={<Ventas />} />

          <Route path="prestamos" element={<Prestamos />} />

          <Route path="movimientos" element={<Movimientos />} />

          <Route path="resumen" element={<Resumen />} />

          <Route
            path="embajadoras"
            element={
              isAdmin ? (
                <EmbajadorasAdmin />
              ) : (
                <Navigate to="/admin/dashboard" />
              )
            }
          />

          <Route
            path="calendario"
            element={
              isAdmin ? (
                <Calendario setActive={setActive} />
              ) : (
                <Navigate to="/admin/dashboard" />
              )
            }
          />

          <Route
            path="experiencias"
            element={
              isAdmin ? (
                <Experiencias />
              ) : (
                <Navigate to="/admin/dashboard" />
              )
            }
          />

          <Route
            path="*"
            element={<Navigate to="/admin/dashboard" />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default function AdminApp() {
  return (
    <AuthProvider>
      <AdminLayout />
    </AuthProvider>
  );
}